import { SearchOutlined } from "@ant-design/icons";
import { RenglonSemaforo } from "../RenglonSemaforo";
import { TituloSemaforo } from "../TituloSemaforo";

export const BuscandoProveedor = ({ asistenciasSemaforo }) => {
  const asistencias = asistenciasSemaforo.filter((a) => a.estatusID === 2);
  return (
    <section className="semaforo-general__columna" aria-label="Buscando proveedor">
      <TituloSemaforo icon={<SearchOutlined />} titulo="Buscando proveedor" count={asistencias.length} />
      {asistencias.length === 0 && <p className="semaforo-general__vacio">Sin asistencias buscando proveedor</p>}
      {asistencias.map((a) => (
        <RenglonSemaforo
          key={a.asistenciaID}
          asistencia={a}
          fecha={a.fechaCapturaTerminada}
        />
      ))}
    </section>
  );
};
